import { connect } from 'react-redux';
import RootSelection from './RootSelection';
import { loadPath, setManagementOption } from '../../actions/booking';
import { openCancelReservationScreen } from '../../actions/cancelling';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  pathSelected: state.booking.path,
  organizationBackgroundImageUrl: state.organization.backgroundImageUrl,
  pathLoaded: state.booking.pathLoaded,
  loginFirst: state.booking.loginFirst,
  loginFirstShowLoginForm: state.booking.loginFirstShowLoginForm,
  uniquePath: state.booking.uniquePath,
  languages: state.organization.languages,
  viaSso: state.session.viaSso,
  fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
  googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId
});
const mapDispatchToProps = dispatch => ({
  loadPath: dispatch(loadPath),
  openCancelReservationScreen() {
    dispatch(openCancelReservationScreen());
  },
  setManagementOption: dispatch(setManagementOption)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RootSelection);



// WEBPACK FOOTER //
// ./src/containers/RootSelection/index.js